import NotFound from '@src/pages/NotFound';
import { createFileRoute } from '@tanstack/react-router';

import { loadClientName } from '../clientTitle';
import { getLocalizedDynamicTitle } from '../title';

export const Route = createFileRoute('/_app/clients/$clientId/')({
  loader: async ({ context, params }) => ({
    clientName: await loadClientName(context.apiClient, params.clientId),
  }),
  head: ({ loaderData }) => ({
    meta: [
      {
        title: getLocalizedDynamicTitle(
          'clients.client_detail.page_title',
          'Client Detail',
          loaderData?.clientName ?? '',
        ),
      },
    ],
  }),
  // A client that does not exist or that the user may not view.
  notFoundComponent: NotFound,
});
